/** Desktop breakpoint aligned with Tailwind `md`. Mobile Lighthouse is 412px. */
export const HERO_VIDEO_MIN_WIDTH_PX = 768

export const HERO_POSTER_SRC = '/video/hero-dive-poster.jpg'
export const HERO_VIDEO_SRC = '/video/hero-dive.mp4'

export function shouldLoadHeroVideo(opts: {
  desktop: boolean
  reducedMotion: boolean
}): boolean {
  return opts.desktop && !opts.reducedMotion
}
